export enum EEquipmentType {
    Streetlight,
    Gateway
}

export const equipmentsTranslateKey = [
    "equipments.lamp",
    "equipments.gateway"
];
